import React from 'react';
import { WizardContainerTemplate } from 'themes/modules/product/wizard/pages';
import { translate, setCurrentView } from 'core/utils';
import { WizardStore } from 'modules/product/wizard/stores';

@setCurrentView(rootStore => new WizardStore(rootStore), 'wizardStore')
class WizardContainer extends React.Component {
	constructor(props) {
		super(props);
		props.wizardStore.initialize(props.config, props.form, props.localStorageKey, props.itemName, props.parentView);
	}

	componentDidMount() {
		window.addEventListener('beforeunload', this.onBeforeUnload);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.onBeforeUnload);
	}

	onBeforeUnload(e) {
		let message = translate('WIZARDLEAVE');
		e.returnValue = message;
		return message;
	}

	render() {
		return <WizardContainerTemplate {...this.props} />;
	}
}

export default WizardContainer;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/pages/WizardContainer.jsx